const toggleCard = {
  TOGGLE_CARD: "TOGGLE_CARD"
};
export default toggleCard;